export enum FilterType {
  Text = 1,
  Dropdown = 2
};

(FilterType as any).__typeName = "FilterType";
